import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ChartBarIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { apiClient } from '../../services/apiClient';

const Reports: React.FC = () => {
  const { data: summaryReport } = useQuery({
    queryKey: ['reports', 'summary'],
    queryFn: () => apiClient.getReports('summary')
  });

  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Reports & Analytics</h1>
        <p className="text-gray-600 mt-2">View comprehensive migration reports and analytics</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
          <ChartBarIcon className="w-8 h-8 text-blue-600 mb-4" />
          <h3 className="text-lg font-semibold mb-2">System Overview</h3>
          <p className="text-gray-600 mb-4">
            Overall system performance and migration statistics
          </p>
          <button className="btn-primary">View Report</button>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
          <DocumentTextIcon className="w-8 h-8 text-green-600 mb-4" />
          <h3 className="text-lg font-semibold mb-2">Customer Reports</h3>
          <p className="text-gray-600 mb-4">
            Customer-specific migration progress and status
          </p>
          <button className="btn-primary">View Report</button>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
          <ChartBarIcon className="w-8 h-8 text-purple-600 mb-4" />
          <h3 className="text-lg font-semibold mb-2">Data Quality</h3>
          <p className="text-gray-600 mb-4">
            Data quality metrics and validation results
          </p>
          <button className="btn-primary">View Report</button>
        </div>
      </div>

      {summaryReport && (
        <div className="mt-8 bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">Summary Statistics</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center p-4 bg-blue-50 rounded-lg">
              <div className="text-2xl font-bold text-blue-600">{summaryReport.activeProjects}</div>
              <div className="text-sm text-gray-600">Active Projects</div>
            </div>
            <div className="text-center p-4 bg-green-50 rounded-lg">
              <div className="text-2xl font-bold text-green-600">{summaryReport.completedProjects}</div>
              <div className="text-sm text-gray-600">Completed</div>
            </div>
            <div className="text-center p-4 bg-yellow-50 rounded-lg">
              <div className="text-2xl font-bold text-yellow-600">{(summaryReport.recordsProcessed / 1000).toFixed(1)}k</div>
              <div className="text-sm text-gray-600">Records Processed</div>
            </div>
            <div className="text-center p-4 bg-purple-50 rounded-lg">
              <div className="text-2xl font-bold text-purple-600">{summaryReport.successRate}%</div>
              <div className="text-sm text-gray-600">Success Rate</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reports;
